var exports = {
  "IW": "VoiceParticipantAvatarList.module__stackAvatar___SHo3WX",
  "K_": "VoiceParticipantAvatarList.module__stackAvatarSpeaking___SHo3WX",
  "Eh": "VoiceParticipantAvatarList.module__wrapContainer___SHo3WX",
  "EN": "VoiceParticipantAvatarList.module__wrapAvatarSlot___SHo3WX",
  "FU": "VoiceParticipantAvatarList.module__wrapAvatarSlotAnimated___SHo3WX",
  "ee": "VoiceParticipantAvatarList.module__wrapAvatar___SHo3WX",
  "lE": "VoiceParticipantAvatarList.module__wrapAvatarAnimated___SHo3WX",
  "i1": "VoiceParticipantAvatarList.module__remainingCount___SHo3WX",
  "jC": "VoiceParticipantAvatarList.module__popoutContainer___SHo3WX",
  "qE": "VoiceParticipantAvatarList.module__popoutList___SHo3WX",
  "Az": "VoiceParticipantAvatarList.module__popoutRow___SHo3WX",
  "ps": "VoiceParticipantAvatarList.module__popoutRowAvatar___SHo3WX",
  "fU": "VoiceParticipantAvatarList.module__popoutRowName___SHo3WX",
};

module.exports = exports;
